import { render, staticRenderFns } from "./ProcessInstanceTabs.vue?vue&type=template&id=2b4a5f57&scoped=true"
import script from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceTabs.vue?vue&type=style&index=0&id=2b4a5f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a5f57",
  null
  
)

export default component.exports